import React, { useState, useEffect } from "react";
import "./Product.css";
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import ProductBG from "../../Assets/about_banner_img.webp";
import productbg from "../../Assets/Product_Page/product_background.webp";
import clear_glass from "../../Assets/Product_Page/clear_glass.webp";
import ultra_clear from "../../Assets/Product_Page/ultra_clear.webp";
import french_green from "../../Assets/Product_Page/french_green.webp";
import crystal_grey from "../../Assets/Product_Page/crystal_grey.webp";
import euro_grey from "../../Assets/Product_Page/euro_grey.webp";
import temperable from "../../Assets/Product_Page/temperable.webp";
import api, { PUBLIC_BASE_URL } from "../../api/api";
import windowGlass from "../../Assets/Product_Page/window_glass.webp";
import carGlass from "../../Assets/Product_Page/car_glass.webp";
import eRickshawGlass from "../../Assets/Product_Page/e_rickshaw_spare_parts_glass.webp";
import automotiveGlass from "../../Assets/Product_Page/automotive_glass.webp";
import commercialVehicleGlass from "../../Assets/Product_Page/commercial_vehicl_glass.webp";
import automobileToughnessGlass from "../../Assets/Product_Page/automobile_toughness_glass.webp";
import Slider from "react-slick";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

const Product = () => {
  NProgress.configure({ showSpinner: false, trickleSpeed: 200 });
  const [loading, setLoading] = useState(true);

  const [groupedCategories, setGroupedCategories] = useState({});

  useEffect(() => {
    NProgress.start();
    api
      .get("/product-categories")
      .then((res) => {
        const grouped = {};
        res.data.forEach((item) => {
          if (!grouped[item.title]) {
            grouped[item.title] = [];
          }
          grouped[item.title].push(item);
        });
        setGroupedCategories(grouped);
      })
      .catch((err) => console.error("Error fetching categories", err))
      .finally(() => {
        NProgress.done(); // Stop NProgress when API finishes
        setLoading(false); // Also set your loading state
      });
  }, []);

  //   const products = [
  //     { image: windowGlass, title: 'Window Glass', link: '/ClearGlass' },
  //     { image: carGlass, title: 'Car Glass', link: '/CrystalGrey' },
  //     { image: eRickshawGlass, title: 'E Rickshaw Spare Parts Glass', link: '/EuroGrey' },
  //     { image: automotiveGlass, title: 'Automotive Glass', link: '/TemperableLowECoatedGlass' },
  //     { image: commercialVehicleGlass, title: 'Commercial Vehicle Glass', link: '/FrenchGreen' },
  //     { image: automobileToughnessGlass, title: 'Automotive Toughened Glass', link: '/UltraClear' }
  // ];

  const productRoutes = {
    "Window Glass": "/ClearGlass",
    "Car Glass": "/CrystalGrey",
    "E Rickshaw Glass": "/EuroGrey",
    // "Automotive Glass": "/TemperableLowECoatedGlass",
    "Commercial Vehicle Glass": "/FrenchGreen",
    "Automotive Toughened Glass": "/UltraClear",
    // "Road & Construction Equipment Glass": "/bullet_proof",
  };

  // Slider settings for customization
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 1000,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // const settings = {
  //   dots: false,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 2,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   autoplaySpeed: 500,
  //   arrows: false,
  // };

  const [bannerData, setBannerData] = useState(null);

  useEffect(() => {
    // Replace this with the actual API endpoint
    api
      .get("/productbanner")
      .then((response) => {
        // console.log("Banner Data:", response.data);
        if (response.data && response.data.length > 0) {
          setBannerData(response.data[0]); // Access the first banner data
        }
      })
      .catch((error) => console.error("Error fetching product banner:", error));
  }, []);

  return (
    <div>
      <Header />

      {/* banner section start  */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: bannerData
            ? `url(${PUBLIC_BASE_URL}${bannerData.image})`
            : "none",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h1>{bannerData ? bannerData.title : "Loading..."}</h1>{" "}
                {/* Render loading text if bannerData is not available */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* banner section end */}

      {/* Float Glass section start */}
      <section
        className="container-fluid float_glass_section"
        style={{
          backgroundImage: `url(${productbg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              {/* Title Section */}
              <div className="common_title fadeInUp text-center mb-4">
                <h1 style={{ color: "rgb(42 111 181)", fontWeight: "700" }}>
                  Automotive Glass & Architechture Glass
                </h1>
              </div>

              {/* Content Section */}
              <div className="content_text wow fadeInUp">
                <p style={{ color: "#333", fontSize: "1rem" }}>
                  Khodiyar Automotive Glass Pvt. Ltd. offers a wide range of
                  Toughened Glass solutions, including both Automotive and
                  Architectural Glass, designed for strength, durability, and
                  safety. Our Automotive Toughened Glass is crafted with the
                  latest technology to provide crack resistance, high strength,
                  and long-lasting performance, ensuring safety and precision
                  fit for vehicles. Similarly, our Architectural Glass is
                  perfect for windows, doors, and facades, offering heat
                  resistance, impact durability, and design flexibility for
                  residential and commercial projects. Both types of glass come
                  with laminated options for enhanced safety and are available
                  in various finishes and thicknesses to meet your specific
                  needs. Khodiyar is committed to delivering glass products that
                  meet the highest industry standards, making us the go-to
                  choice for automotive manufacturers, builders, and designers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Float Glass section end  */}


      {/* ProductSorts section end   */}

      <section className="container-fluid productsorts_section">
        <div className="container" style={{ width: "100%", maxWidth: "100%" }}>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div
                className="owl-carousel viedo_carousel_section"
                id="resources_carousel"
              >
                <Slider {...settings}>
                  {Object.entries(groupedCategories).map(
                    ([title, items], index) =>
                      items.map((product, i) => (
                        <div key={`${index}-${i}`} className="px-2">
  <div
    style={{
      border: "1px solid #ddd",
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      backgroundColor: "#fff",
      transition: "transform 0.3s",
      height: "100%",
    }}
  >
    <img
      src={`${PUBLIC_BASE_URL}${product.image}`}
      alt={product.product}
      style={{
        width: "100%",
        height: "200px",
        objectFit: "cover",
      }}
    />
    <div className="bottom-part" style={{ padding: "16px" }}>
      <h5 style={{ margin: 0, fontSize: "18px",  }}>
        {product.product}
      </h5>
      <div style={{ marginTop: "10px" }}>
        <Link
          to={`/${product.product
            .replace(/\s+/g, "")
            .replace(/[^a-zA-Z]/g, "")}`}
          className="btn btn-sm btn-outline-primary text-dark "
          style={{ textDecoration: "none" }}
        >
          Read More
        </Link>
      </div>
    </div>
  </div>
</div>

                      ))
                  )}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Product;
